// extracted by mini-css-extract-plugin
module.exports = {"copy-icon":"CopyIcon__copy-icon___oomxf"};